import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    // Benutzer nicht eingeloggt, leite zum Login weiter
    // Übergebe die ursprüngliche Ziel-URL, damit wir nach dem Login dorthin zurück können (optional)
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!currentUser.emailVerified) {
      // Benutzer eingeloggt, aber E-Mail nicht verifiziert
      // Leite zur Verifizierungsseite weiter
      // Übergebe die E-Mail zur Anzeige
      return <Navigate to="/verify-email" state={{ email: currentUser.email }} replace />;
  }

  // Benutzer ist eingeloggt und E-Mail ist verifiziert
  return <>{children}</>;
};

export default ProtectedRoute; 